module.exports = __webpack_public_path__ + "img/delete_device.1c69ccf3.svg";